// SPDX-FileCopyrightText: 2025 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF

import React from 'react';
import { useAppSelector } from 'store/hooks';
import DataDetailImage from '../data/detail/DataDetailImage';
import PanZoomImage from './PanZoomImg';

interface Props {
  imageBase64?: string;
}

export default function AlgorithmsImage({ imageBase64 }: Readonly<Props>) {
  const { selectedMd5 } = useAppSelector(s => s.image);

  if (imageBase64) {
    return <PanZoomImage imageBase64={imageBase64} />;
  }
  return <DataDetailImage imageId={selectedMd5} />;
}
